import { HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { IApiResponse } from '@core/interfaces/api-response.interface';
import { ComponentStore } from '@ngrx/component-store';
import { TCampaignApi } from '@pages/campaigns/campaigns.interface';
import { CampaignsService } from '@pages/campaigns/campaigns.service';
import { EMPTY, Observable } from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs/operators';
import { ICreatorAndBudgetDialogState } from './creator-and-budget-dialog.interface';
import { getCampaignFilterOptions } from './creator-and-budget-dialog.util';

const initialState: ICreatorAndBudgetDialogState = {
  campaignOptions: null,
  campaignOptionsFailed: false,
  campaignOptionsLoading: false,
};

@Injectable()
export class CreatorAndBudgetDialogStore extends ComponentStore<ICreatorAndBudgetDialogState> {
  public readonly campaignOptions$ = this.selectSignal((state) => state.campaignOptions);
  public readonly campaignOptionsLoading$ = this.selectSignal((state) => state.campaignOptionsLoading);
  public readonly campaignOptionsFailed$ = this.selectSignal((state) => state.campaignOptionsFailed);

  private readonly campaignsService = inject(CampaignsService);

  constructor() {
    super(initialState);
  }

  public readonly fetchCampaignOptions = this.effect((currentCampaignId$: Observable<string | null>) => {
    return currentCampaignId$.pipe(
      tap(() => this.patchState({ campaignOptionsFailed: false, campaignOptionsLoading: true })),
      switchMap((currentCampaignId) =>
        this.campaignsService
          .getCampaigns(
            new HttpParams().set('limit', '1000').set('order_by', '-created_at').set('joins', 'campaign_creators'),
          )
          .pipe(
            tap((campaigns: IApiResponse<TCampaignApi[]>) => {
              this.patchState({
                campaignOptions: getCampaignFilterOptions(campaigns.data ?? [], currentCampaignId),
                campaignOptionsLoading: false,
              });
            }),
            catchError(() => {
              this.patchState({ campaignOptionsFailed: true, campaignOptionsLoading: false });

              return EMPTY;
            }),
          ),
      ),
    );
  });
}
